import { render, staticRenderFns } from "./authorizationAgreement.vue?vue&type=template&id=57b8feae&scoped=true"
import script from "./authorizationAgreement.vue?vue&type=script&lang=js"
export * from "./authorizationAgreement.vue?vue&type=script&lang=js"
import style0 from "./authorizationAgreement.vue?vue&type=style&index=0&id=57b8feae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8feae",
  null
  
)

export default component.exports